import { MessageCircle, Mail } from "lucide-react";
import { useLingui } from "@lingui/react/macro";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export function HelpCenterHeader() {
  const { t } = useLingui();

  // Live chat / ticket submission are placeholders until the support backend lands.
  const notReady = () => toast.info(t`Support channels are coming soon.`);

  return (
    <div className="flex items-center justify-between gap-3 px-3">
      <div className="flex flex-col gap-2">
        <h1 className="text-5xl font-semibold tracking-tight text-(--color-text-primary)">
          {t`Help Center`}
        </h1>
        <p className="text-base text-(--gray-500)">
          {t`Search docs, onboarding, and troubleshooting.`}
        </p>
      </div>

      <div className="flex shrink-0 items-center gap-3">
        <Button variant="brand-outline" className="h-13" onClick={notReady}>
          <MessageCircle className="size-6" />
          {t`Live Chat`}
        </Button>
        <Button className="h-13 rounded-[0.625rem]" onClick={notReady}>
          <Mail className="size-6" />
          {t`Submit Ticket`}
        </Button>
      </div>
    </div>
  );
}
